<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    class="chat-svg"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7353 11.4125V14.575L15.4708 11.4125H9.08364C7.94814 11.4125 6.95459 10.45 6.95459 9.35V2.0625C6.95459 0.962499 7.94814 0 9.08364 0H19.8708C21.0063 0 21.9998 0.962499 21.9998 2.0625V9.35C21.9998 10.45 21.0063 11.4125 19.8708 11.4125H18.7353Z"
    />
    <path
      d="M3.26454 22V18.15H2.69679C1.27743 18.15 0 17.05 0 15.5375V8.25C0 6.875 1.13549 5.6375 2.69679 5.6375H5.39358V9.21249C5.39358 11.275 7.09682 12.7875 9.08393 12.7875H16.0388V15.4C16.0388 16.775 14.9033 18.0125 13.342 18.0125H7.23875L3.26454 22Z"
    />
    <path
      d="M2.6968 6.73749C1.84518 6.73749 1.1355 7.42499 1.1355 8.24999V15.5375C1.1355 16.3625 1.84518 17.05 2.6968 17.05H4.2581V19.3875L6.67102 17.05H13.342C14.1936 17.05 14.9033 16.3625 14.9033 15.5375V14.025H9.08393C6.38714 14.025 4.2581 11.9625 4.2581 9.34999V6.73749H2.6968Z"
    />
  </svg>
</template>
<script>
export default {
  name: 'Chat'
}
</script>
<style lang="sass">
.chat-svg
  fill: currentColor
</style>
